import { render, staticRenderFns } from "./historico-movimento.vue?vue&type=template&id=2f2aa76b&scoped=true&"
import script from "./historico-movimento.vue?vue&type=script&lang=js&"
export * from "./historico-movimento.vue?vue&type=script&lang=js&"
import style0 from "./historico-movimento.vue?vue&type=style&index=0&id=2f2aa76b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2aa76b",
  null
  
)

export default component.exports